import React from "react";

const Checkbox = ({ id, inputName, label, checkType, checkVal, disabled }) => {
  return (
    <span className="check-span">
      <input
        type="checkbox"
        value={id}
        id={id}
        name={inputName}
        onClick={!disabled ? checkType : null}
        checked={checkVal.toString().includes(id)}
        readOnly
      />
      <label htmlFor={id} className={`${disabled ? "selected" : ""}`}>
        Furnished <span>{label}</span>
      </label>
    </span>
  );
};

export default Checkbox;
